module.exports = __webpack_public_path__ + "0dbf193d85b0eb977d9ee02f910fc158.svg";